module.exports = __webpack_public_path__ + "img/expired.25f64b26.png";